import * as api from 'app/shared/api';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from "app/pages/DiscountEditor/actionTypes";
import { getBasicDetailsDto } from "app/pages/DiscountEditor/modules/BasicInfo";
import { DiscountDto } from "app/shared/model/DiscountDto";
import { getProductDtos } from "app/pages/DiscountEditor/modules/ProductSelection";
import { getDateFilterDto } from "app/pages/DiscountEditor/modules/DiscountDates";
import { getCountryFilterDto } from "app/pages/DiscountEditor/modules/CountrySelection";
import { getAgentFilterDto } from "app/pages/DiscountEditor/modules/Agent";
import { getDiscountActionDtos } from "app/pages/DiscountEditor/modules/DiscountActions";
import { getId } from 'app/pages/DiscountEditor/modules/Editor/selectors';
import { saveStarted, saveComplete, saveError, saveInvalid } from 'app/pages/DiscountEditor/actions';
import { getAdditionalCriteriaDto } from 'app/pages/DiscountEditor/modules/AdditionalCriteria';
import { getDivisionsDto } from "app/pages/DiscountEditor/modules/Divisions";
import { DiscountType } from "app/shared/model/DiscountType";
import { validatePromotionCodeFormat } from "app/shared/validation/promotionCode";
import { SaveDiscountErrorCategory } from "app/shared/model/SaveDiscountResultDto";

export type SaveState = {
    changeNumber: number
    savedNumber: number
    savingNumber: number|undefined
}

function getDiscountDto(state: any) : DiscountDto {
    const [schoolFilter, productsFilter, unitsFilter] = getProductDtos(state);
    const divisionFilter = getDivisionsDto(state);
    
    return {
        basicDetails: getBasicDetailsDto(state),
        schoolsFilter: schoolFilter,
        datesFilter: getDateFilterDto(state),
        productFilter: productsFilter,
        unitsFilter: unitsFilter,
        countryFilter: getCountryFilterDto(state),
        agentsFilter: getAgentFilterDto(state),
        divisionFilter: divisionFilter,
        actions: getDiscountActionDtos(state), 
        additionalCriteria: getAdditionalCriteriaDto(state)
    };
}

export function saveDiscount() {
    return async function(dispatch: ThunkDispatch<any, any, Action>, getState: () => any) : Promise<boolean> {
        const state = getState();
        const id = getId(state);
        const isNew = !id;
        const dto = getDiscountDto(state);
        const basic = dto.basicDetails;

        if (basic.discountType === DiscountType.specialOffer && basic.PromotionCode) {
            const formatErr = validatePromotionCodeFormat(basic.PromotionCode);
            if (formatErr) {
                dispatch(saveInvalid({
                    successful: false,
                    errors: [{ category: SaveDiscountErrorCategory.BasicInfo, message: formatErr }]
                }));
                return false;
            }
        }

        dispatch(saveStarted(isNew));

        const savePromise = id
            ? api.putDiscount(id, dto)
            : api.postDiscount(dto);

        try {
            const result = await savePromise;
            if (result?.successful) {
                dispatch(saveComplete(result, isNew));
                return true;
            }
            dispatch(saveInvalid(result));
            return false;
        } catch {
            dispatch(saveError());
            return false;
        }
    };
}